import { render, staticRenderFns } from "./CircleChart.vue?vue&type=template&id=0638c2b2&scoped=true&"
import script from "./CircleChart.vue?vue&type=script&lang=js&"
export * from "./CircleChart.vue?vue&type=script&lang=js&"
import style0 from "./CircleChart.vue?vue&type=style&index=0&id=0638c2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0638c2b2",
  null
  
)

export default component.exports